import React from "react";
import { fmtNumber, fmtCurrency } from "@/lib/api";
import { ChevronDown } from "lucide-react";

const COLORS = ["#0f172a", "#0369a1", "#0284c7", "#d97706", "#2563eb", "#059669"];

export function SalesFunnelChart({ stages, onStageClick }) {
  const max = Math.max(...stages.map((s) => s.count), 1);
  return (
    <div className="space-y-2" data-testid="sales-funnel">
      {stages.map((s, i) => {
        const width = Math.max((s.count / max) * 100, 8);
        return (
          <div key={s.key}>
            <button
              onClick={() => onStageClick?.(s.key)}
              data-testid={`funnel-stage-${s.key}`}
              className="w-full group text-left"
            >
              <div className="flex items-center gap-4">
                <div className="w-32 sm:w-40 flex-shrink-0 text-right">
                  <p className="text-sm font-medium text-slate-700 truncate">{s.label}</p>
                  {s.value > 0 && <p className="text-[11px] text-slate-400">{fmtCurrency(s.value)}</p>}
                </div>
                <div className="flex-1 relative h-11">
                  <div
                    className="h-full rounded-md flex items-center px-3 transition-all duration-300 group-hover:brightness-110 group-hover:shadow-md"
                    style={{ width: `${width}%`, backgroundColor: COLORS[i % COLORS.length] }}
                  >
                    <span className="text-white font-bold text-sm font-display">{fmtNumber(s.count)}</span>
                  </div>
                </div>
              </div>
            </button>
            {i < stages.length - 1 && (
              <div className="flex items-center gap-4 py-0.5">
                <div className="w-32 sm:w-40 flex-shrink-0" />
                <div className="flex items-center gap-1.5 text-xs text-slate-400 pl-1">
                  <ChevronDown className="h-3.5 w-3.5" />
                  <span className="font-medium text-slate-500">{stages[i + 1].conversion}% conversion</span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
